<template>
<div class="header">
    <div @click="showMark" class="list-icon"></div>
    <div class="header-icon"></div>
    <div class="login">
        <div @click="loginHandle" v-if="!isLogin">
            <span>登录</span>|<span>注册</span>
        </div>
        <div v-if="isLogin" @click="checkHandle" class="login-icon">
            <i></i>
        </div>
        <div v-if="isLoginContainer" class="login-container">
            <ul>
                <li @click="logout">退出登录</li>
                <li @click="changeUser">切换账号</li>
            </ul>
        </div>
    </div>
</div>
</template>
<script>
import config from '../../config.js'
import {yxEncript,yxDecript} from '../../utils/tool'
export default {
    data() {
        return {
            isLogin: false,
            isLoginContainer: false,
        }
    },
    props: {
        isMark: {
            Object,
            default: function() {
                return {}
            }
        }
    },
    mounted() {
        this.path = (this.$route.path).replace('/', '')
        var urlParam = this.$route.query
        // if (urlParam.userInfo) {
        //     let nowUserInfo=JSON.parse(yxDecript(urlParam.userInfo))
        //     this.$storage.setItem('user', {
        //         'accessKey': nowUserInfo.accessKey,
        //         'userId': nowUserInfo.userId,
        //         'thirdUserNo': nowUserInfo.thirdUserNo
        //     })
        //
        // }
        if(urlParam.accessKey){
            this.$storage.setItem('user',{
                'accessKey':urlParam.accessKey,
                'userId':urlParam.userId,
                'thirdUserNo':urlParam.thirdUserNo
            })
        }
        if (this.$storage.getItem('user').accessKey) {
            this.isLogin = true
        } else {
            this.isLogin = false
        }
    },
    methods: {
        showMark() {
            this.isMark.show = true
        },
        checkHandle() {
            this.isLoginContainer = true
        },
        logout() {
            this.$storage.init()
            this.isLogin = false
            this.isLoginContainer = false
        },
        changeUser() {
            this.loginForH5(this.path)
        },
        loginHandle() {
            this.loginForH5(this.path)
        },
        finLogin(route) {
            let url = encodeURIComponent(window.location.protocol + '//' + window.location.host + window.location.pathname + '')
            let href = ''
            switch (config.ENV) {
                case '-test':
                    href = 'https://one-test.zhongan.com/sh/dd-login/#/index?redirect='
                    break
                case '-uat':
                    href = 'https://one-uat.zhongan.com/sh/dd-login/#/index?redirect='
                    break
                case '':
                    href = 'https://fin-app.zhongan.com/sh/dd-login/index.html#/index?redirect='
                    break
            }
            window.location.href = href + this.callBackUrl(route)
        },
        loginForH5(route) {
            //h5
            let url = ''
            switch (config.ENV) {
                case '-test':
                    if (window.location.href.indexOf('http://127.0.0.1') > -1) {
                        url = 'https://one-test.zhongan.com/account/nydd-service/index.html#/verify?campaignNo=diandianguanwang&callback='
                    } else {
                        url = 'https://one-test.zhongan.com/fcp/diandian-oa/index.html#/?campaignNo=diandianguanwang&redirectUrl='
                    }
                    break;
                case '-uat':
                    url = 'https://one-uat.zhongan.com/fcp/diandian-oa/index.html#/?campaignNo=diandianguanwang&redirectUrl='
                    break;
                case '':
                    url = 'https://fin-app.zhongan.com/sh/diandian-oa/index.html#/?campaignNo=diandianguanwang&redirectUrl='
                    break;
            }
            window.location.href = url + this.callBackUrl(route)
        },
        callBackUrl(route) {
            let cb = ''
            switch (config.ENV) {
                case '-test':
                    if (window.location.href.indexOf('http://127.0.0.1') > -1) {
                        cb = 'http://127.0.0.1:8087/#/' + route + ''
                    } else {
                        cb = 'https://one-test.zhongan.com/fcp/diandian-home/#/' + route + ''
                    }
                    break;
                case '-uat':
                    cb = 'https://one-uat.zhongan.com/fcp/diandian-home/#/' + route + ''
                    break;
                case '':
                    // ' + route + '
                    cb = 'https://www.diandian.com.cn/'
                    break;
            }
            return encodeURIComponent(cb)
        }
    }
}
</script>



// WEBPACK FOOTER //
// index.vue?05cb7d7c